import * as Yup from "yup";
import Loading from "../Loading";
import { useFormik } from "formik";
import styles from "./styles.module.css";
import { postcodeRegex } from "@/data/consts";
import PostcodeResult from "../PostcodeResult";
import PostcodeCheckerForm from "../PostcodeForm";

const PostcodeChecker: React.FC<{
	setPostcode: (postcode: string) => void;
	hasResults: boolean;
	resultsTitle: React.ReactNode;
	formTitle: React.ReactNode;
	isloading: boolean;
}> = ({ setPostcode, hasResults, resultsTitle, formTitle, isloading }) => {
	const formik = useFormik({
		initialValues: { postcode: "" },
		validationSchema: Yup.object().shape({
			postcode: Yup.string().matches(
				postcodeRegex,
				"Please enter a valid postcode"
			),
		}),
		onSubmit: (values, { setSubmitting }) => {
			setSubmitting(false);
			setPostcode(values.postcode);
		},
	});

	const handleReset = () => {
		setPostcode("");
		formik.resetForm();
	};

	return (
		<div>
			<div className={`d-flex flex-column p-3  pe-md-5  me-lg-5`}>
				<div className={`me-lg-5`}>
					<div
						className={`row d-flex justify-content-center mt-3 p-4 ${styles.postcode__container}`}
					>
						{isloading ? (
							<Loading />
						) : hasResults ? (
							<PostcodeResult handleReset={handleReset}>
								{resultsTitle}
							</PostcodeResult>
						) : (
							<PostcodeCheckerForm formik={formik}>
								{formTitle}
							</PostcodeCheckerForm>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PostcodeChecker;
